import React from 'react';
import noop from 'lodash/noop';
import PropTypes from 'prop-types';

import Pagination from 'eventbrite_design_system/pagination/Pagination';
import Icon from 'eventbrite_design_system/icon/Icon';
import HelpChunkySVG from 'eventbrite_design_system/iconography/icons/HelpChunky';
import NewWindowChunkySVG from 'eventbrite_design_system/iconography/icons/NewWindowChunky';
import Guidance from 'eventbrite_design_system/guidance/Guidance';

import {
    CONFLICT_FOOTER_PROPS_TYPES,
    CONFLICTS_TRANSLATIONS,
    MAX_CONFLICT_WITHOUT_PAGINATION,
} from '../../constants/downgrade';

const EventsConflictsPagination = ({
    pageNumber,
    pageCount,
    paginationSize,
    onPageChange,
    shouldUsePagination,
}) =>
    shouldUsePagination ? (
        <div
            className="eds-l-mn-pad-top-4 eds-l-md-pad-top-4 eds-l-sw-pad-top-4 eds-l-sm-pad-top-8 eds-l-sn-pad-top-8"
            data-spec="downgrade-conflict-pagination"
        >
            <Pagination
                pageNumber={pageNumber}
                pageCount={pageCount}
                size={paginationSize}
                onSelected={onPageChange}
            />
        </div>
    ) : null;

const LINK_CONFIG = {
    linkText: CONFLICTS_TRANSLATIONS.table.guidanceTextLink,
    linkTo: CONFLICTS_TRANSLATIONS.table.guidanceLink,
    linkIcon: (
        <Icon type={<NewWindowChunkySVG />} size="xsmall" color="ui-blue" />
    ),
    onLinkClick: noop,
};

const EventsConflictsTableFooter = ({
    paginationSize,
    pageNumber,
    pageCount,
    onPageChange,
    objectCount,
}) => (
    <section
        className="eds-l-lg-mar-bot-10 eds-l-ln-mar-bot-10 eds-l-lw-mar-bot-10 eds-l-md-mar-bot-10 eds-l-mn-mar-bot-10 eds-l-mw-mar-bot-10 eds-l-sw-mar-bot-10"
        data-spec="downgrade-conflict-footer"
    >
        <Guidance
            data-spec="downgrade-conflict-guidance"
            textContent={CONFLICTS_TRANSLATIONS.table.guidanceText}
            linkConfig={LINK_CONFIG}
            primaryIcon={<Icon type={<HelpChunkySVG />} />}
        />
        <EventsConflictsPagination
            pageNumber={pageNumber}
            pageCount={pageCount}
            paginationSize={paginationSize}
            onPageChange={onPageChange}
            shouldUsePagination={objectCount > MAX_CONFLICT_WITHOUT_PAGINATION}
        />
    </section>
);

EventsConflictsTableFooter.propTypes = {
    ...CONFLICT_FOOTER_PROPS_TYPES,
    paginationSize: PropTypes.string,
    onPageChange: PropTypes.func.isRequired,
};

export default EventsConflictsTableFooter;
